import styles from "./CardSectionImageMenu.module.scss";

import React from "react";
import Media from "../../../../CmsComponents/Media/Media";
import RichText from "../../../../CmsComponents/RichText/RichText";
import BNLink from "../../../../BnComponents/BNLink/BNLink";
import { BNButton } from "@bn-monorepo/js-packages";

interface MenuButton {
  img?: string;
  alt: string;
  name: string;
  info: string;
  href: string;
  isSpa: boolean;
}
interface Props {
  menuButtons: MenuButton[];
  title: string;
  enabled?: boolean;
}

const CardSectionImageMenu: React.FC<Props> = (props) => {
  const { title, menuButtons, enabled } = props;
  if (!enabled) return null;
  return (
    <section className={styles.mainWrapper}>
      <div className={styles.containerWrapper}>
        {title && <h2 className={styles.header}>{title}</h2>}
        {menuButtons && (
          <nav aria-label={`image-menu: ${title}`}>
            <ul className={styles.menuContainer}>
              {menuButtons.map((button, index) => (
                <li key={`menuButtons-${index}`} className={styles.menuElement}>
                  <BNLink isSpa={button.isSpa} href={button.href} className={styles.linkContainer}>
                    {button.img && (
                      <Media
                        AltText={button.alt}
                        imagePath={button.img}
                        className={styles.image}
                        noWrapper={true}
                        maxWidth={260}
                        aspectRatio={"260:110"}
                      />
                    )}
                    <BNButton
                      variant="contained"
                      sx={{
                        px: 1,
                        py: 0.5,
                        borderRadius: "50em",
                        position: "relative",
                        zIndex: "100",
                        textAlign: "center",
                        opacity: "0.8",
                        "&:hover": {
                          opacity: 1,
                        },
                      }}
                      color="secondary"
                    >
                      {button.name}
                    </BNButton>
                  </BNLink>
                  <div className={styles.text}>
                    <RichText html={button.info} />
                  </div>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </section>
  );
};

export default CardSectionImageMenu;
